import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./AddProduct.css";

const AddProduct = () => {
  const navigate = useNavigate();
  const [modelFile, setModelFile] = useState(null);

  const [formData, setFormData] = useState({
    title: "",
    price: "",
    description: "",
    path: "",
    color: "",
    is3D: false,
    size: [],
    availableColors: [],
  });

  const [newSize, setNewSize] = useState("");
  const [newColor, setNewColor] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const addSize = () => {
    if (newSize) {
      setFormData({ ...formData, size: [...formData.size, newSize] });
      setNewSize("");
    }
  };

  const addColor = () => {
    if (newColor) {
      setFormData({
        ...formData,
        availableColors: [...formData.availableColors, newColor],
      });
      setNewColor("");
    }
  };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       await axios.post("http://localhost:5600/api/products", formData);
//       alert("Product added successfully!");
//       // Optionally redirect or reset form
//     } catch (err) {
//       console.error("Error adding product", err);
//       alert("Failed to add product");
//     }
//   };
const handleSubmit = async (e) => {
  e.preventDefault();

  const formDataToSend = new FormData();
  formDataToSend.append("title", formData.title);
  formDataToSend.append("price", formData.price);
  formDataToSend.append("description", formData.description);
  formDataToSend.append("color", formData.color);
  formDataToSend.append("is3D", formData.is3D);
  formDataToSend.append("size", JSON.stringify(formData.size));
  formDataToSend.append(
    "availableColors",
    JSON.stringify(formData.availableColors)
  );

  if (modelFile) {
    formDataToSend.append("model", modelFile); // <-- this uploads the .glb
  }

  try {
    await axios.post(
      `${process.env.REACT_APP_BACKEND_SERVER}/api/products/upload`,
      formDataToSend,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    alert("Product added with model!");
  } catch (err) {
    console.error(err);
    alert("Upload failed");
  }
};
  
  

  return (
    <div className="add-product-container">
      <h2 style={{ color: "#e6651b" }}>Add New Product</h2>
      <form className="add-product-form" onSubmit={handleSubmit}>
        {/* Product Title */}
        <label>Product Title:</label>
        <input
          type="text"
          name="title"
          value={formData.title}
          onChange={handleChange}
          placeholder="Enter Product Title"
          required
        />

        {/* Price */}
        <label>Product Price:</label>
        <input
          type="number"
          name="price"
          value={formData.price}
          onChange={handleChange}
          placeholder="Enter Price"
          required
        />

        {/* Description */}
        <label>Description:</label>
        <textarea
          name="description"
          value={formData.description}
          onChange={handleChange}
          placeholder="Enter product description"
          rows="4"
        />

        {/* GLB Model Path */}
        <label>Upload GLB Model:</label>
        <input
          type="file"
          accept=".glb,.gltf"
          onChange={(e) => setModelFile(e.target.files[0])}
        />

        {/* Main Color */}
        <label>Main Color (Hex):</label>
        <input
          type="text"
          name="color"
          value={formData.color}
          onChange={handleChange}
          placeholder="#FF5733"
        />

        {/* Is 3D */}
        <label>
          <input
            type="checkbox"
            name="is3D"
            checked={formData.is3D}
            onChange={(e) =>
              setFormData({ ...formData, is3D: e.target.checked })
            }
          />
          Is 3D Product?
        </label>

        {/* Sizes */}
        <div className="multi-field-section">
          <label>Add Sizes:</label>
          <input
            type="text"
            value={newSize}
            onChange={(e) => setNewSize(e.target.value)}
            placeholder="e.g., 6, 7, 8"
          />
          <button type="button" onClick={addSize}>
            Add Size
          </button>
          <div>
            {formData.size.map((size, index) => (
              <span key={index} style={{ marginRight: "8px" }}>
                {size}
              </span>
            ))}
          </div>
        </div>

        {/* Available Colors */}
        <div className="multi-field-section">
          <label>Add Available Color (Hex):</label>
          <input
            type="text"
            value={newColor}
            onChange={(e) => setNewColor(e.target.value)}
            placeholder="#FF5733"
          />
          <button type="button" onClick={addColor}>
            Add Color
          </button>
          <div style={{ marginTop: "8px", display: "flex", gap: "6px" }}>
            {formData.availableColors.map((color, index) => (
              <div
                key={index}
                style={{
                  width: "20px",
                  height: "20px",
                  backgroundColor: color,
                  borderRadius: "50%",
                  border: "1px solid #000",
                }}
                title={color}
              ></div>
            ))}
          </div>
        </div>

        {/* Submit */}
        <button type="submit" className="submit-btn">
          Add Product
        </button>
      </form>
    </div>
  );
};

export default AddProduct;
